module.exports = __webpack_public_path__ + "img/gift_dark.94b68fc3.png";